import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "category-tabs" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = { style: {"margin-top":"1em"} }
const _hoisted_8 = { type: "submit" }

import { ref, reactive, onMounted,computed } from 'vue'
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin from '@fullcalendar/list'
import koLocale from '@fullcalendar/core/locales/ko'
import Header from '@/components/admin/adminHeader.vue'
import Sidebar from '@/components/admin/adminSidebar.vue'
import axios from '@/api/plan'
import Swal from 'sweetalert2'

interface CalendarEvent {
  no: number 
  title: string
  content: string
  start: string
  end?: string
  crt: number
}

// 카테고리 매핑

export default /*@__PURE__*/_defineComponent({
  __name: 'insertPlan',
  setup(__props) {

const categories: Record<number, string> = {
  1: '음방',
  2: '자컨',
  3: '방송',
  4: '무대',
  5: '팬미팅',
  6: '곡발매',
  7: '생일',
}

const calendarEvents = ref<CalendarEvent[]>([])
const colors = ref([]);
const isModalOpen = ref(false)
const selectedDate = ref('')
const selectedEventIndex = ref<number | null>(null)

const form = reactive({
  no: 1,
  title: '',
  startTime: '09:00',
  endTime: '10:00',
  crt: 1,
})

const times = []
for (let h = 0; h < 24; h++) {
  for (let m = 0; m < 60; m += 10) {
    const hh = h.toString().padStart(2, '0')
    const mm = m.toString().padStart(2, '0')
    times.push(`${hh}:${mm}`)
  }
}

const calendarOptions = reactive({
  plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin],
  locale: koLocale,
  dayMaxEventRows: true,
  eventDisplay: 'block',
  initialView: window.innerWidth < 920 ? 'listWeek' : 'dayGridMonth',
  headerToolbar: {
    left: 'prev,next today',
    center: 'title',
    right: window.innerWidth < 920 ? '' : 'dayGridMonth,timeGridWeek,timeGridDay',
  },
  buttonText: {
    today: '오늘',
    month: '월간',
    week: '주간',
    day: '일간',
    list: '리스트',
  },
  events: computed(() => calendarEvents.value),
  eventDidMount(info: any) {
    info.el.style.position = 'relative'
    info.el.style.zIndex = '10'
    info.el.style.transition = 'transform 0.2s ease'
    info.el.addEventListener('mouseenter', () => {
      info.el.style.transform = 'scale(1.05)'
      info.el.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.2)'
      info.el.style.zIndex = '10'
      info.el.style.cursor = 'pointer'
    })
    info.el.addEventListener('mouseleave', () => {
      info.el.style.transform = 'scale(1)'
      info.el.style.boxShadow = ''
      info.el.style.zIndex = ''
    })
  },
  dayCellDidMount(info: any) {
    const dateStr = info.date.toISOString().slice(0, 10)
    const eventsForThisDay = calendarEvents.value.filter(event =>
      event.start.startsWith(dateStr)
    )
    if (eventsForThisDay.length > 0) {
      const tooltipContent = eventsForThisDay
        .map(ev => `• ${ev.title} (${new Date(ev.start).getHours()}시)`)
        .join('\n')
      info.el.setAttribute('title', tooltipContent)
    }
  },
  eventClick(info: any) {
    // 클릭한 이벤트 인덱스 찾기
    const clickedEvent = info.event
    const idx = calendarEvents.value.findIndex(ev => 
      ev.title === clickedEvent.title
    )
    if (idx !== -1) {
      openModalForEdit(idx)
    } else {
      
      alert('이벤트를 찾을 수 없습니다.')
    }
  },
  dateClick(info: any) {
    selectedDate.value = info.dateStr
    selectedEventIndex.value = null
    openModal()
  },
})




async function fetchPlan() {
  try {
    const response = await axios.ListPlan()
    calendarEvents.value = response.data || []
    colors.value = response.data.map(event => event.backgroundColor);
    console.log(response.data)

  } catch (error) {
    console.error('일정 목록을 불러오는 데 실패했습니다:', error)
  }
}

function openModal() {
  form.no = 1
  form.title = ''
  form.startTime = '09:00'
  form.endTime = '10:00'
  form.crt = 1
  isModalOpen.value = true
}

function openModalForEdit(index: number) {
  const ev = calendarEvents.value[index]
  selectedEventIndex.value = index
  selectedDate.value = ev.start.slice(0, 10)
   form.no = ev.no 
  form.title = ev.title
  form.startTime = ev.start.slice(11, 16)
  form.endTime = ev.end ? ev.end.slice(11, 16) : '10:00'
  form.crt = ev.crt
  isModalOpen.value = true
  console.log('form.category:', form.crt, typeof form.crt)
}

function closeModal() {
  isModalOpen.value = false
  selectedEventIndex.value = null
}

async function submitEvent() {
  const newEvent = {
    no: form.no,
    title: form.title,
    startAt: `${selectedDate.value}T${form.startTime}`,
    endAt: `${selectedDate.value}T${form.endTime}`,
    crt: form.crt,
  }
    if (selectedEventIndex.value !== null) {
      await axios.getUpdatePlan(newEvent)
   
  } else {
   await axios.getInsertPlan(newEvent);
    
  }
  await fetchPlan()
  closeModal()
     await Swal.fire({
        icon: 'success',
        title: '완료',
        text: '일정이 성공적으로 적용되었습니다.',
        timer: 1500,
        showConfirmButton: false,
      })
}

async function deleteEvent() {
  if (selectedEventIndex.value !== null) {
    const eventToDelete = calendarEvents.value[selectedEventIndex.value]

    const confirmed = confirm(`일정 "${eventToDelete.title}"을(를) 삭제하시겠습니까?`)
    if (!confirmed) return

    try {
      await axios.getDeletePlan(form.no)
      await fetchPlan()
      closeModal()
        closeModal()
        await Swal.fire({
          icon: 'success',
          title: '삭제 완료',
          text: '일정이 성공적으로 삭제되었습니다.',
          timer: 1500,
          showConfirmButton: false,
        })
      } catch (error) {
        console.error('일정 삭제 실패:', error)
        await Swal.fire({
          icon: 'error',
          title: '삭제 실패',
          text: '일정 삭제에 실패했습니다.',
        })
      }
    } 
  }

onMounted(() => {
  fetchPlan();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Sidebar),
      _createVNode(_unref(FullCalendar), {
        options: calendarOptions,
        class: "fullcalendars"
      }, null, 8, ["options"]),
      (isModalOpen.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal-overlay",
            onClick: _withModifiers(closeModal, ["self"])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h3", null, _toDisplayString(selectedEventIndex.value !== null ? '일정 수정' : '일정 추가'), 1),
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(categories, (name, num) => {
                  return _createElementVNode("button", {
                    key: num,
                    type: "button",
                    class: _normalizeClass({ active: form.crt === Number(num) }),
                    onClick: ($event: any) => (form.crt = Number(num))
                  }, _toDisplayString(name), 11, _hoisted_4)
                }), 64))
              ]),
              _createElementVNode("form", {
                onSubmit: _withModifiers(submitEvent, ["prevent"])
              }, [
                _createElementVNode("div", null, [
                  _cache[3] || (_cache[3] = _createElementVNode("label", null, "일정 제목:", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.title) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, form.title]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[4] || (_cache[4] = _createElementVNode("label", null, "시작 시간:", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.startTime) = $event)),
                    required: ""
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(times, (time) => {
                      return _createElementVNode("option", {
                        key: time,
                        value: time
                      }, _toDisplayString(time), 9, _hoisted_5)
                    }), 64))
                  ], 512), [
                    [_vModelSelect, form.startTime]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", null, "종료 시간:", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.endTime) = $event)),
                    required: ""
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(times, (time) => {
                      return _createElementVNode("option", {
                        key: time,
                        value: time
                      }, _toDisplayString(time), 9, _hoisted_6)
                    }), 64))
                  ], 512), [
                    [_vModelSelect, form.endTime]
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", _hoisted_8, _toDisplayString(selectedEventIndex.value !== null ? '수정 완료' : '추가'), 1),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: closeModal
                  }, " 취소 "),
                  (selectedEventIndex.value !== null)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        style: {"margin-left":"auto","background":"#f56c6c","color":"white"},
                        onClick: deleteEvent
                      }, " 삭제 "))
                    : _createCommentVNode("", true)
                ])
              ], 32)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})